import { createContext, useReducer, useCallback } from "react";

import useHome from "../../hooks/user/useHome";
import axios from "../../utils/axios/v1/userAxios";
import { WafType, WafAction } from "../../utils/constants";
import { normalizeWafEventTimeRange } from "../../components/pages/_new/detection/wafEventListUtils";

const GET_EVENTS = "GET_EVENTS";
const GET_FW_EVENTS = "GET_FW_EVENTS";
const GET_BOT_EVENTS = "GET_BOT_EVENTS";
const GET_AUTH_EVENTS = "GET_AUTH_EVENTS";
const GET_RL_EVENTS = "GET_RL_EVENTS";
const GET_SMARTPARSE_EVENTS = "GET_SMARTPARSE_EVENTS";
const GET_TOTAL_EVENTS_COUNT = "GET_TOTAL_EVENTS_COUNT";
const GET_TOTAL_FW_EVENTS_COUNT = "GET_TOTAL_FW_EVENTS_COUNT";
const GET_TOTAL_BOT_EVENTS_COUNT = "GET_TOTAL_BOT_EVENTS_COUNT";
const GET_TOTAL_AUTH_EVENTS_COUNT = "GET_TOTAL_AUTH_EVENTS_COUNT";
const GET_TOTAL_RL_EVENTS_COUNT = "GET_TOTAL_RL_EVENTS_COUNT";
const GET_TOTAL_SMARTPARSE_EVENTS_COUNT = "GET_TOTAL_SMARTPARSE_EVENTS_COUNT";
const SET_CURRENT_STATUS = "SET_CURRENT_STATUS";
const GET_SINGLE_EVENT = "GET_SINGLE_EVENT";
const GET_SINGLE_FW_EVENT = "GET_SINGLE_FW_EVENT";
const GET_SINGLE_BOT_EVENT = "GET_SINGLE_BOT_EVENT";
const GET_SINGLE_AUTH_EVENT = "GET_SINGLE_AUTH_EVENT";
const GET_SINGLE_RL_EVENT = "GET_SINGLE_RL_EVENT";
const GET_SINGLE_SMARTPARSE_EVENT = "GET_SINGLE_SMARTPARSE_EVENT";
const GET_WAF_EVENT_STATS = "GET_WAF_EVENT_STATS";
const GET_FW_EVENT_STATS = "GET_FW_EVENT_STATS";
const GET_BOT_EVENT_STATS = "GET_BOT_EVENT_STATS";
const GET_RL_EVENT_STATS = "GET_RL_EVENT_STATS";
const GET_SMARTPARSE_EVENT_STATS = "GET_SMARTPARSE_EVENT_STATS";
const SET_ERROR = "SET_ERROR";
const SET_EVENT_DETAIL_LOADING = "SET_EVENT_DETAIL_LOADING";

const initialState = {
  site_id: "all",
  time_range: { period: "7d" },
  events: null,
  event: null,
  fwEvents: null,
  fwEvent: null,
  botEvents: null,
  botEvent: null,
  authEvents: null,
  authEvent: null,
  rlEvents: null,
  rlEvent: null,
  smartParseEvents: null,
  smartParseEvent: null,
  wafEventStats: null,
  fwEventStats: null,
  botEventStats: null,
  rlEventStats: null,
  smartParseEventStats: null,
  total_events_count: 0,
  total_fw_events_count: 0,
  total_bot_events_count: 0,
  total_rl_events_count: 0,
  total_smartparse_events_count: 0,
  rows_per_page: 5,
  from: 0,
  action: 3,
  conditions: [],
  errMsg: null,
  fwEventLoading: false,
  botEventLoading: false,
  rlEventLoading: false,
  smartParseEventLoading: false,
};

const EventReducer = (state, action) => {
  switch (action.type) {
    case GET_EVENTS:
      return {
        ...state,
        events: action.payload.events,
      };
    case GET_FW_EVENTS:
      return {
        ...state,
        fwEvents: action.payload.fwEvents,
      };
    case GET_BOT_EVENTS:
      return {
        ...state,
        botEvents: action.payload.botEvents,
      };
    case GET_AUTH_EVENTS:
      return {
        ...state,
        authEvents: action.payload.authEvents,
      };
    case GET_RL_EVENTS:
      return {
        ...state,
        rlEvents: action.payload.rlEvents,
      };
    case GET_SMARTPARSE_EVENTS:
      return {
        ...state,
        smartParseEvents: action.payload.smartParseEvents,
      };
    case GET_TOTAL_EVENTS_COUNT:
      return {
        ...state,
        total_events_count: action.payload.total_events_count,
      };
    case GET_TOTAL_FW_EVENTS_COUNT:
      return {
        ...state,
        total_fw_events_count: action.payload.total_fw_events_count,
      };
    case GET_TOTAL_BOT_EVENTS_COUNT:
      return {
        ...state,
        total_bot_events_count: action.payload.total_bot_events_count,
      };
    case GET_TOTAL_AUTH_EVENTS_COUNT:
      return {
        ...state,
        total_auth_events_count: action.payload.total_auth_events_count,
      };
    case GET_TOTAL_RL_EVENTS_COUNT:
      return {
        ...state,
        total_rl_events_count: action.payload.total_rl_events_count,
      };
    case GET_TOTAL_SMARTPARSE_EVENTS_COUNT:
      return {
        ...state,
        total_smartparse_events_count: action.payload.total_smartparse_events_count,
      };
    case GET_SINGLE_EVENT:
      return {
        ...state,
        event: action.payload.event,
      };
    case GET_SINGLE_FW_EVENT:
      return {
        ...state,
        fwEvent: action.payload.fwEvent,
      };
    case GET_SINGLE_BOT_EVENT:
      return {
        ...state,
        botEvent: action.payload.botEvent,
      };
    case GET_SINGLE_AUTH_EVENT:
      return {
        ...state,
        authEvent: action.payload.authEvent,
      };
    case GET_SINGLE_RL_EVENT:
      return {
        ...state,
        rlEvent: action.payload.rlEvent,
      };
    case GET_SINGLE_SMARTPARSE_EVENT:
      return {
        ...state,
        smartParseEvent: action.payload.smartParseEvent,
      };
    case GET_WAF_EVENT_STATS:
      return {
        ...state,
        wafEventStats: action.payload.wafEventStats,
      };
    case GET_FW_EVENT_STATS:
      return {
        ...state,
        fwEventStats: action.payload.fwEventStats,
      };
    case GET_BOT_EVENT_STATS:
      return {
        ...state,
        botEventStats: action.payload.botEventStats,
      };
    case GET_RL_EVENT_STATS:
      return {
        ...state,
        rlEventStats: action.payload.rlEventStats,
      };
    case GET_SMARTPARSE_EVENT_STATS:
      return {
        ...state,
        smartParseEventStats: action.payload.smartParseEventStats,
      };
    case SET_CURRENT_STATUS:
      return {
        ...state,
        site_id: action.payload.site_id,
        time_range: action.payload.time_range,
        rows_per_page: action.payload.rows_per_page,
        from: action.payload.from,
        action: action.payload.action,
        conditions: action.payload.conditions,
      };
    case SET_ERROR:
      return {
        ...state,
        errMsg: action.payload.errMsg,
      };
    case SET_EVENT_DETAIL_LOADING: {
      const { scope, loading } = action.payload;
      const key =
        scope === "fw"
          ? "fwEventLoading"
          : scope === "bot"
            ? "botEventLoading"
            : scope === "rl"
              ? "rlEventLoading"
              : scope === "smartParse"
                ? "smartParseEventLoading"
                : null;
      if (!key) return state;
      return { ...state, [key]: loading };
    }
    default:
      return state;
  }
};

const EventContext = createContext(null);

let tmpController;

function EventProvider({ children }) {
  const { curProjectId } = useHome();
  const [state, dispatch] = useReducer(EventReducer, initialState);

  const setErr = useCallback((msg) => {
    dispatch({
      type: SET_ERROR,
      payload: {
        errMsg: msg,
      },
    });
  }, []);

  // Old getEvents callback, deprecated and not using now.
  const getEvents = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      dispatch({
        type: GET_TOTAL_EVENTS_COUNT,
        payload: {
          total_events_count: 0,
        },
      });
      try {
        const response = await axios.post(
          "log/waf_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            conditions: conditions,
            action: action,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        console.error("=== WAF Events List API Error ===", err);
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: [],
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );

  const getEvents2 = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          conditions: conditions,
        },
      });
      dispatch({
        type: GET_TOTAL_EVENTS_COUNT,
        payload: {
          total_events_count: 0,
        },
      });
      try {
        const response = await axios.post(
          "log/waf_event2",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            conditions: conditions,
            waf_type: WafType.SIGNATURE,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: [],
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getFwEvents = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_FW_EVENTS,
          payload: {
            fwEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      dispatch({
        type: GET_TOTAL_FW_EVENTS_COUNT,
        payload: {
          total_fw_events_count: 0,
        },
      });
      try {
        const response = await axios.post(
          "log/fw_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            action: action,
            conditions: conditions,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_FW_EVENTS,
          payload: {
            fwEvents: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_FW_EVENTS_COUNT,
          payload: {
            total_fw_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_FW_EVENTS,
          payload: {
            fwEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_FW_EVENTS_COUNT,
          payload: {
            total_fw_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getOnlyFwEvents = useCallback(
    async (site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_FW_EVENTS,
          payload: {
            fwEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      tmpController = new AbortController();
      const signal = tmpController.signal;
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      try {
        const response = await axios.post(
          "log/fw_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            action: action,
            conditions: conditions,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_FW_EVENTS,
          payload: {
            fwEvents: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_FW_EVENTS_COUNT,
          payload: {
            total_fw_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_FW_EVENTS,
          payload: {
            fwEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_FW_EVENTS_COUNT,
          payload: {
            total_fw_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getOnlyEvents = useCallback(
    async (site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      tmpController = new AbortController();
      const signal = tmpController.signal;
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      try {
        const response = await axios.post(
          "log/waf_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            conditions: conditions,
            action: action,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: [],
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getOnlyEvents2 = useCallback(
    async (site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      tmpController = new AbortController();
      const signal = tmpController.signal;
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      try {
        const response = await axios.post(
          "log/waf_event2",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            conditions: conditions,
            action: action,
            waf_type: WafType.SIGNATURE,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_EVENTS,
          payload: {
            events: [],
          },
        });
        dispatch({
          type: GET_TOTAL_EVENTS_COUNT,
          payload: {
            total_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getEvent = useCallback(
    async (eventID) => {
      dispatch({
        type: GET_SINGLE_EVENT,
        payload: {
          event: null,
        },
      });
      try {
        const response = await axios.get(`log/waf_event/${eventID}`);
        dispatch({
          type: GET_SINGLE_EVENT,
          payload: {
            event: response.data,
          },
        });
      } catch (err) {
        console.error("=== WAF Event Detail API Error ===", err);
        dispatch({
          type: GET_SINGLE_EVENT,
          payload: {
            event: null,
          },
        });
        setErr(err.message);
      }
    },
    [setErr]
  );
  const getFwEvent = useCallback(
    async (eventID) => {
      dispatch({
        type: SET_EVENT_DETAIL_LOADING,
        payload: { scope: "fw", loading: true },
      });
      dispatch({
        type: GET_SINGLE_FW_EVENT,
        payload: {
          fwEvent: null,
        },
      });
      try {
        const response = await axios.get(`log/fw_event/${eventID}`);
        dispatch({
          type: GET_SINGLE_FW_EVENT,
          payload: {
            fwEvent: response.data,
          },
        });
      } catch (err) {
        dispatch({
          type: GET_SINGLE_FW_EVENT,
          payload: {
            fwEvent: null,
          },
        });
        setErr(err.message);
      } finally {
        dispatch({
          type: SET_EVENT_DETAIL_LOADING,
          payload: { scope: "fw", loading: false },
        });
      }
    },
    [setErr]
  );
  const getBotEvents = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_BOT_EVENTS,
          payload: {
            botEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      dispatch({
        type: GET_TOTAL_BOT_EVENTS_COUNT,
        payload: {
          total_bot_events_count: 0,
        },
      });
      try {
        const response = await axios.post(
          "log/bot_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            action: action,
            conditions: conditions,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_BOT_EVENTS,
          payload: {
            botEvents: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_BOT_EVENTS_COUNT,
          payload: {
            total_bot_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_BOT_EVENTS,
          payload: {
            botEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_BOT_EVENTS_COUNT,
          payload: {
            total_bot_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );

  const getOnlyBotEvents = useCallback(
    async (site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_BOT_EVENTS,
          payload: {
            botEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      tmpController = new AbortController();
      const signal = tmpController.signal;
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      try {
        const response = await axios.post(
          "log/bot_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            conditions: conditions,
            action: action,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_BOT_EVENTS,
          payload: {
            botEvents: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_BOT_EVENTS_COUNT,
          payload: {
            total_bot_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_BOT_EVENTS,
          payload: {
            botEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_BOT_EVENTS_COUNT,
          payload: {
            total_bot_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );

  const getBotEvent = useCallback(
    async (eventID) => {
      dispatch({
        type: SET_EVENT_DETAIL_LOADING,
        payload: { scope: "bot", loading: true },
      });
      dispatch({
        type: GET_SINGLE_BOT_EVENT,
        payload: {
          botEvent: null,
        },
      });
      try {
        const response = await axios.get(`log/bot_event/${eventID}`);
        dispatch({
          type: GET_SINGLE_BOT_EVENT,
          payload: {
            botEvent: response.data,
          },
        });
      } catch (err) {
        dispatch({
          type: GET_SINGLE_BOT_EVENT,
          payload: {
            botEvent: null,
          },
        });
        setErr(err.message);
      } finally {
        dispatch({
          type: SET_EVENT_DETAIL_LOADING,
          payload: { scope: "bot", loading: false },
        });
      }
    },
    [setErr]
  );

  const getRlEvents = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_RL_EVENTS,
          payload: {
            rlEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      dispatch({
        type: GET_TOTAL_RL_EVENTS_COUNT,
        payload: {
          total_rl_events_count: 0,
        },
      });
      try {
        const response = await axios.post(
          "log/rl_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            action: action,
            conditions: conditions,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_RL_EVENTS,
          payload: {
            rlEvents: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_RL_EVENTS_COUNT,
          payload: {
            total_rl_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_RL_EVENTS,
          payload: {
            rlEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_RL_EVENTS_COUNT,
          payload: {
            total_rl_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );

  const getOnlyRlEvents = useCallback(
    async (site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_RL_EVENTS,
          payload: {
            rlEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      tmpController = new AbortController();
      const signal = tmpController.signal;
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      try {
        const response = await axios.post(
          "log/rl_event",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            count: rows_per_page,
            from: from,
            conditions: conditions,
            action: action,
            sort: { field: "timestamp", order: "desc" },
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_RL_EVENTS,
          payload: {
            rlEvents: response.data.data,
          },
        });
        dispatch({
          type: GET_TOTAL_RL_EVENTS_COUNT,
          payload: {
            total_rl_events_count: response.data.total,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_RL_EVENTS,
          payload: {
            rlEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_RL_EVENTS_COUNT,
          payload: {
            total_rl_events_count: 0,
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );

  const getRlEvent = useCallback(
    async (eventID) => {
      dispatch({
        type: SET_EVENT_DETAIL_LOADING,
        payload: { scope: "rl", loading: true },
      });
      dispatch({
        type: GET_SINGLE_RL_EVENT,
        payload: {
          rlEvent: null,
        },
      });
      try {
        const response = await axios.get(`log/rl_event/${eventID}`);
        dispatch({
          type: GET_SINGLE_RL_EVENT,
          payload: {
            rlEvent: response.data,
          },
        });
      } catch (err) {
        dispatch({
          type: GET_SINGLE_RL_EVENT,
          payload: {
            rlEvent: null,
          },
        });
        setErr(err.message);
      } finally {
        dispatch({
          type: SET_EVENT_DETAIL_LOADING,
          payload: { scope: "rl", loading: false },
        });
      }
    },
    [setErr]
  );

  const getWafEventStats = useCallback(
    async (setWafEventController, site_id, time_range, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_WAF_EVENT_STATS,
          payload: {
            wafEventStats: null,
          },
        });
      }
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      try {
        const response = await axios.post(
          "stats/detection",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            waf_type: WafType.ALL,
            conditions,
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_WAF_EVENT_STATS,
          payload: {
            wafEventStats: response.data,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_WAF_EVENT_STATS,
          payload: {
            wafEventStats: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getFwEventStats = useCallback(
    async (setWafEventController, site_id, time_range, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_FW_EVENT_STATS,
          payload: {
            fwEventStats: null,
          },
        });
      }
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      try {
        const response = await axios.post(
          "fw_stats/stats",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            waf_type: WafType.ALL,
            conditions,
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_FW_EVENT_STATS,
          payload: {
            fwEventStats: response.data,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_FW_EVENT_STATS,
          payload: {
            fwEventStats: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getBotEventStats = useCallback(
    async (setWafEventController, site_id, time_range, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_BOT_EVENT_STATS,
          payload: {
            botEventStats: null,
          },
        });
      }
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      try {
        const response = await axios.post(
          "bot_stats/stats",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            conditions,
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_BOT_EVENT_STATS,
          payload: {
            botEventStats: response.data,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_BOT_EVENT_STATS,
          payload: {
            botEventStats: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );
  const getRlEventStats = useCallback(
    async (setWafEventController, site_id, time_range, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_RL_EVENT_STATS,
          payload: {
            rlEventStats: null,
          },
        });
      }
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      try {
        const response = await axios.post(
          "rl_stats/stats",
          {
            site_id: site_id,
            project_id: curProjectId,
            time_range: time_range,
            conditions,
          },
          {
            signal,
          }
        );
        dispatch({
          type: GET_RL_EVENT_STATS,
          payload: {
            rlEventStats: response.data,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_RL_EVENT_STATS,
          payload: {
            rlEventStats: [],
          },
        });
        setErr(err.message);
      }
    },
    [setErr, curProjectId]
  );

  const getSmartParseEvents = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, action, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_SMARTPARSE_EVENTS,
          payload: {
            smartParseEvents: null,
          },
        });
      }
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      dispatch({
        type: GET_TOTAL_SMARTPARSE_EVENTS_COUNT,
        payload: {
          total_smartparse_events_count: 0,
        },
      });
      try {
        const body = {
          time_range: normalizeWafEventTimeRange(time_range),
          count: rows_per_page,
          from: from,
          conditions: conditions || [],
          action: action ?? WafAction.ALL,
          sort: { field: "timestamp", order: "desc" },
        };
        if (curProjectId) body.project_id = curProjectId;
        if (site_id && site_id !== "all") body.site_id = site_id;
        const response = await axios.post("log/waf_event", body, { signal });
        const eventsData = response.data.data || [];
        const totalCount = response.data.total ?? (Array.isArray(eventsData) ? eventsData.length : 0);
        dispatch({
          type: GET_SMARTPARSE_EVENTS,
          payload: {
            smartParseEvents: Array.isArray(eventsData) ? eventsData : [],
          },
        });
        dispatch({
          type: GET_TOTAL_SMARTPARSE_EVENTS_COUNT,
          payload: {
            total_smartparse_events_count: totalCount,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_SMARTPARSE_EVENTS,
          payload: {
            smartParseEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_SMARTPARSE_EVENTS_COUNT,
          payload: {
            total_smartparse_events_count: 0,
          },
        });
        setErr(err?.message || String(err));
      }
    },
    [setErr, curProjectId]
  );

  const normalizeWafEventDetail = (rich) => {
    if (!rich) return null;

    const splitCsvToArray = (value) => {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (typeof value !== "string") return [];
      return value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    };
    const toArray = (value) => {
      if (Array.isArray(value)) return value.filter(Boolean);
      if (typeof value === "string" && value.trim()) return [value.trim()];
      return [];
    };

    /** formatSmartParseCanonical envelope (v2 or legacy JSON shape) */
    if (
      rich.event &&
      rich.network &&
      rich.request &&
      rich.intent_tags &&
      typeof rich.intent_tags === "object" &&
      !Array.isArray(rich.intent_tags) &&
      !Array.isArray(rich.rule_details)
    ) {
      const e = rich.event;
      const net = rich.network;
      const req = rich.request;
      const atRaw = e.attack_type;
      const attackTypes = Array.isArray(atRaw) ? atRaw.filter(Boolean) : atRaw ? [atRaw] : splitCsvToArray(rich.categories);
      const categoriesDetected =
        Array.isArray(rich.categories) && rich.categories.length ? rich.categories : attackTypes;
      return {
        id: e.id,
        action: rich.action,
        source: undefined,
        waf_type: rich.waf_type || rich.source_table || undefined,
        source_table: rich.source_table,
        timestamp: e.timestamp,
        type: e.type,
        attack_types: attackTypes,
        categories_detected: categoriesDetected,
        verdict: e.verdict,
        risk_level: e.risk_level ?? rich.max_severity,
        confidence: typeof e.confidence === "number" ? e.confidence : undefined,
        summary: e.summary || "",
        country_iso_code: net.geo?.country_iso,
        country_name: net.geo?.country,
        host_name: req.host,
        uri: req.uri,
        method: req.method,
        query_string: req.query_string,
        ua: req.headers?.user_agent,
        ja3_hash: net.fingerprints?.ja3,
        res_status: rich.response?.status_code,
        request_id: rich.correlation?.request_id,
        attacks: rich.attacks || [],
        network: net,
        abuseip: net.ip_reputation,
        intent_tags: rich.intent_tags,
        decision: rich.decision,
        correlation: rich.correlation,
        request: req,
        response: rich.response,
        links: rich.links || {},
        rule_id: undefined,
        rule_name: undefined,
        waf_action: rich.action,
        raw: rich,
        cwe_ids: (rich.attacks || []).map((a) => a.cwe).filter(Boolean),
        mitre_ids: (rich.attacks || []).map((a) => a.mitre).filter(Boolean),
        detected_intents: [],
        attack_objective: rich.explanation || "",
        remediation: Array.isArray(rich.recommendations) ? rich.recommendations : [],
        rule_details: [],
        ip_reputation: net.ip_reputation,
        campaign: rich.campaign ?? null,
      };
    }

    /** v2 ClickHouse smartparse row (parseSmartParseRow) */
    if (rich.source_table === "layerd-v2-smartparse-events") {
      const at = Array.isArray(rich.attack_types) ? rich.attack_types.filter(Boolean) : [];
      const parseIntentTagsValue = (val) => {
        if (Array.isArray(val)) return val;
        if (typeof val === "string" && val.trim()) {
          try {
            const j = JSON.parse(val);
            if (Array.isArray(j)) return j;
          } catch (_e) {
            return [];
          }
        }
        return [];
      };
      let parsedIntentTags = parseIntentTagsValue(rich.intent_tags);
      if (parsedIntentTags.length === 0 && rich.raw && typeof rich.raw === "object") {
        parsedIntentTags = parseIntentTagsValue(rich.raw.intent_tags);
      }
      let parsedRemediation = [];
      if (Array.isArray(rich.remediation)) {
        parsedRemediation = rich.remediation;
      } else if (typeof rich.remediation === "string" && rich.remediation.trim()) {
        try {
          const j = JSON.parse(rich.remediation);
          if (Array.isArray(j)) parsedRemediation = j.filter((v) => typeof v === "string" && v.trim());
        } catch (_e) {
          parsedRemediation = [];
        }
      }
      return {
        id: rich.id,
        action: rich.action_taken || rich.waf_action,
        timestamp: rich.timestamp,
        attack_types: at.length ? at : (rich.attacks || []).map((a) => a.attack_type).filter(Boolean),
        categories_detected: rich.categories_detected || at,
        verdict: rich.verdict,
        risk_level: rich.risk_level,
        confidence: typeof rich.confidence === "number" ? rich.confidence : undefined,
        summary: rich.summary || "",
        country_iso_code: rich.country_iso_code,
        country_name: rich.country_name,
        host_name: rich.host_name,
        uri: rich.request_uri || rich.uri,
        method: rich.method,
        ua: rich.user_agent,
        ja3_hash: rich.ja3_hash,
        res_status: rich.resStatus,
        request_id: rich.request_id,
        attacks: rich.attacks || [],
        intent_tags: parsedIntentTags,
        waf_type: "smart_parse",
        network: {
          source_ip: rich.src_ip || rich.ip,
          source_port: rich.source_port || null,
          destination_ip: rich.dest_ip || null,
          destination_port: rich.dest_port || null,
          origin_ip: rich.origin_ip || null,
          geo: {
            country_iso: rich.country_iso_code,
            country: rich.country_name,
            city: rich.city || null,
            region: rich.region || null,
            timezone: rich.timezone || null,
          },
          fingerprints: { ja3: rich.ja3_hash },
          ip_reputation: rich.ip_reputation || {},
        },
        correlation: rich.correlation || {},
        request: {
          host: rich.host_name,
          uri: rich.request_uri || rich.uri,
          method: rich.method,
          http_version: rich.http_version || null,
          alpn: rich.alpn || null,
          headers: { user_agent: rich.user_agent },
        },
        response: { status: rich.resStatus },
        raw: rich,
        detected_intents: parsedIntentTags,
        attack_objective: rich.summary || "",
        remediation: parsedRemediation,
        rule_details: [],
        links: {},
        ip_reputation: rich.ip_reputation,
        source_table: rich.source_table,
        user_agent: rich.user_agent,
        action_taken: rich.action_taken,
        status: rich.status,
        ip: rich.ip,
        host: rich.host,
        uri_raw: rich.uri,
        intent: rich.intent,
        attacker_objective: rich.attacker_objective,
        campaign: rich.campaign ?? (rich.raw && typeof rich.raw === "object" ? rich.raw.campaign : null),
      };
    }

    /** v2 WAF / firewall row (parseAuditLogRow) */
    if (rich.source_table === "layerd-v2-waf-events" || rich.source_table === "layerd-v2-firewall-events") {
      const rid = rich.rule_id != null ? String(rich.rule_id) : "";
      const reason = rich.reason != null ? String(rich.reason) : "";
      const attackTypes = rid ? [rid] : reason ? [reason] : [];
      return {
        id: rich.id,
        timestamp: rich.timestamp,
        attack_types: attackTypes,
        categories_detected: rich.categories_detected || attackTypes,
        host_name: rich.host_name,
        uri: rich.uri,
        method: rich.method,
        ua: rich.ua || rich.user_agent,
        ja3_hash: rich.ja3_hash || rich.fp,
        res_status: rich.resStatus,
        request_id: rich.request_id,
        rule_id: rid || undefined,
        summary: reason || rid || "",
        risk_level: rich.risk_level,
        network: {
          source_ip: rich.src_ip,
          geo: { country_iso: rich.country_iso_code, country: rich.country_name },
          fingerprints: { ja3: rich.ja3_hash || rich.fp },
          ip_reputation: rich.ip_reputation || {},
        },
        request: {
          host: rich.host_name,
          uri: rich.uri,
          method: rich.method,
          headers: { user_agent: rich.ua || rich.user_agent },
        },
        response: { status: rich.resStatus },
        raw: rich,
        rule_details: rich.rule_details || [],
        detected_intents: [],
        remediation: [],
        links: {},
        ip_reputation: rich.ip_reputation,
      };
    }

    const safeParseJson = (value) => {
      if (value && typeof value === "object") return value;
      if (typeof value !== "string" || !value.trim()) return null;
      const text = value.trim();
      const decodeHexEscapes = (input) => input.replace(/\\x([0-9a-fA-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
      const parseCandidates = [text, decodeHexEscapes(text)];
      try {
        for (const candidate of parseCandidates) {
          const parsed = JSON.parse(candidate);
          if (parsed && typeof parsed === "object") return parsed;
        }
      } catch (_err) {
        // continue fallback
      }
      return null;
    };
    const parsedRuleMatchJsonList = (Array.isArray(rich.rule_details) ? rich.rule_details : [])
      .map((detail) => safeParseJson(detail?.matchJson))
      .filter(Boolean);
    const ruleMatchPayload =
      parsedRuleMatchJsonList.find((item) => Array.isArray(item?.detected_intents)) ||
      parsedRuleMatchJsonList[0] ||
      null;
    const smartParseJson = safeParseJson(rich.smart_parse_json);
    const detectedIntentsSource =
      (Array.isArray(smartParseJson?.detected_intents) && smartParseJson.detected_intents) ||
      (Array.isArray(ruleMatchPayload?.detected_intents) && ruleMatchPayload.detected_intents) ||
      [];
    const detectedIntents = detectedIntentsSource
      .map((intent) => {
        const classification = intent?.classification || {};
        const signals = Array.isArray(intent?.signals) ? intent.signals.filter(Boolean) : [];
        return {
          intent_id: intent?.intent_id || "",
          intent_name: intent?.intent_name || intent?.intent || "",
          verified: intent?.verified,
          severity: classification?.severity || intent?.severity || intent?.risk_level || "",
          cwe_id: classification?.cwe_id || intent?.cwe_id || "",
          cwe_name: classification?.cwe_name || intent?.cwe_name || "",
          mitre_id: classification?.mitre_id || intent?.mitre_id || "",
          mitre_tactic: classification?.mitre_tactic || intent?.mitre_tactic || "",
          owasp_category: classification?.owasp_category || intent?.owasp_category || "",
          description: classification?.description || intent?.description || "",
          signals,
        };
      })
      .filter((intent) => intent.intent_name || intent.intent_id);
    const attackTypes =
      Array.isArray(rich.attack_types) && rich.attack_types.length
        ? rich.attack_types.filter(Boolean)
        : toArray(rich.attack_type).length > 0
        ? toArray(rich.attack_type)
        : splitCsvToArray(rich.sp_attack_types);
    const categoryFallback = splitCsvToArray(rich.sp_attack_types);
    const categoriesDetected =
      Array.isArray(rich.categories) && rich.categories.length > 0
        ? rich.categories
        : Array.isArray(rich.categories_detected) && rich.categories_detected.length > 0
        ? rich.categories_detected
        : categoryFallback;
    const summary =
      rich.summary ||
      smartParseJson?.intent ||
      ruleMatchPayload?.intent ||
      rich.sp_summary ||
      rich.sp_attack_types ||
      "";
    const confidenceValue =
      rich.confidence ??
      smartParseJson?.confidence ??
      ruleMatchPayload?.confidence;
    const confidence =  Number(confidenceValue) ? Number(confidenceValue) * (Number(confidenceValue) <= 1 ? 100 : 1)
      : undefined;
    const attackObjective =
      smartParseJson?.attacker_objective ||
      ruleMatchPayload?.attacker_objective ||
      rich.sp_explanation ||
      "";
    const remediationFromRich = Array.isArray(rich.sp_recommendations)
      ? rich.sp_recommendations
      : [];
    const remediation = [...new Set([
      ...(Array.isArray(smartParseJson?.remediation) ? smartParseJson.remediation : []),
      ...(Array.isArray(ruleMatchPayload?.remediation) ? ruleMatchPayload.remediation : []),
      ...remediationFromRich,
    ])].filter((item) => typeof item === "string" && item.trim());

    const requestHeadersRaw = rich.request_headers || rich.raw?.request_headers || "";
    const headerMap = typeof requestHeadersRaw === "string"
      ? requestHeadersRaw
          .split("\n")
          .map((line) => line.trim())
          .filter(Boolean)
          .reduce((acc, line) => {
            const sep = line.indexOf(":");
            if (sep > -1) {
              const key = line.slice(0, sep).trim().toLowerCase();
              const value = line.slice(sep + 1).trim();
              acc[key] = value;
            }
            return acc;
          }, {})
      : {};

    const net = rich.network && typeof rich.network === "object" ? rich.network : {
      source_ip: rich.src_ip || rich.source_address,
      source_port: rich.source_port,
      destination_ip: rich.destination_address,
      destination_port: rich.destination_port,
      geo: {
        country_iso: rich.country_iso_code || rich.geo_country_code,
        country: rich.country_name || rich.geo_country_name,
        city: rich.city || rich.geo_city_name,
        region: rich.region || rich.geo_region_name,
        timezone: rich.timezone || rich.geo_timezone,
      },
      fingerprints: {
        ja3: rich.ja3_hash || rich.ja3_fingerprint,
      },
      ip_reputation: rich.ip_reputation || {},
    };
    const req = rich.request && typeof rich.request === "object" ? rich.request : {
      host: rich.host_name || rich.host,
      uri: rich.uri || rich.requested_uri,
      method: rich.method || rich.http_request_method,
      query_string: rich.query_string,
      protocol: rich.incoming_protocol || rich.server_protocol,
      body: rich.request_body,
      headers_raw: requestHeadersRaw,
      headers: {
        user_agent: rich.ua || rich.user_agent_original || headerMap["user-agent"],
      },
    };
    const res = rich.response && typeof rich.response === "object" ? rich.response : {
      status: rich.res_status || rich.resStatus || rich.http_response_status_code,
      headers_raw: rich.response_headers,
    };
    const geo = net.geo || {};
    const fingerprints = net.fingerprints || {};

    return {
      id: rich.id,
      action: rich.action,
      source: rich.waf_type,
      waf_type: rich.waf_type,
      timestamp: rich.timestamp,
      type: rich.log_type,
      attack_types: attackTypes,
      categories_detected: categoriesDetected,
      verdict: rich.sp_verdict,
      risk_level: smartParseJson?.risk_level || rich.sp_risk_level || rich.max_severity,
      confidence,
      summary,
      country_iso_code: geo.country_iso || rich.country_iso_code || rich.geo_country_code,
      country_name: geo.country || rich.country_name || rich.geo_country_name,
      host_name: req.host || rich.host_name || rich.host,
      uri: req.uri || rich.uri || rich.requested_uri,
      method: req.method || rich.method || rich.http_request_method,
      query_string: req.query_string,
      ua: req.headers?.user_agent || rich.ua || rich.user_agent_original,
      ja3_hash: fingerprints.ja3 || rich.ja3_hash || rich.ja3_fingerprint,
      res_status: rich.res_status || rich.resStatus || rich.http_response_status_code,
      request_id: rich.request_id,
      attacks: rich.attacks || [],
      network: net,
      abuseip: net.ip_reputation || rich.ip_reputation,
      intent_tags: rich.intent_tags || [],
      decision: rich.decision,
      correlation: rich.correlation,
      request: req,
      response: res,
      links: rich.links || {},
      rule_id: rich.rule?.id || rich.rule_id,
      rule_name: rich.rule?.name || rich.rule_name,
      waf_action: rich.waf_action || rich.action || rich.action,
      raw: rich,
      cwe_ids: (rich.attacks || []).map((a) => a.cwe).filter(Boolean),
      mitre_ids: (rich.attacks || []).map((a) => a.mitre).filter(Boolean),
      detected_intents: detectedIntents,
      attack_objective: attackObjective,
      remediation,
      rule_details: rich.rule_details,
      ip_reputation: rich.ip_reputation,
    };
  };

  const getSmartParseEvent = useCallback(
    async (event_id, wafEvent = "smartparse_waf") => {
      dispatch({
        type: SET_EVENT_DETAIL_LOADING,
        payload: { scope: "smartParse", loading: true },
      });
      dispatch({
        type: GET_SINGLE_SMARTPARSE_EVENT,
        payload: {
          smartParseEvent: null,
        },
      });
      try {
        // Always request the v3 envelope for Smart Parse detail drawer.
        const response = await axios.get(`log/waf_event/${event_id}`, {
          params: { waf_event: wafEvent, schema: "v3" },
        });
        const payload = response.data && response.data.schema_version === "layerd.waf.event.v3"
          ? response.data
          : null;
        dispatch({
          type: GET_SINGLE_SMARTPARSE_EVENT,
          payload: {
            smartParseEvent: payload,
          },
        });
      } catch (err) {
        dispatch({
          type: GET_SINGLE_SMARTPARSE_EVENT,
          payload: {
            smartParseEvent: null,
          },
        });
        setErr(err.message);
      } finally {
        dispatch({
          type: SET_EVENT_DETAIL_LOADING,
          payload: { scope: "smartParse", loading: false },
        });
      }
    },
    [setErr]
  );

  // Tier-3: fetch related events for a burst group. The :group_id in
  // the URL is opaque; the (src_ip, intent_name, host, path) tuple
  // from the row's `correlation` block is the actual query. Returns
  // the raw envelope from the server so the modal can render shape
  // straight; throws on non-2xx so the modal can surface the error.
  const getSmartParseEventGroup = useCallback(
    async (groupId, body) => {
      if (!groupId || !body || !body.src_ip || !body.intent_name || !body.host || !body.path) {
        throw new Error("getSmartParseEventGroup: missing groupId or tuple");
      }
      const response = await axios.post(
        `log/smart_parse_groups/${encodeURIComponent(groupId)}`,
        body,
      );
      return response.data;
    },
    []
  );

  const getOnlySmartParseEvents = useCallback(
    async (setWafEventController, site_id, time_range, rows_per_page, from, action, conditions) => {
      if (tmpController) tmpController.abort();
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      dispatch({
        type: SET_CURRENT_STATUS,
        payload: {
          site_id: site_id,
          time_range: time_range,
          rows_per_page: rows_per_page,
          from: from,
          action: action,
          conditions: conditions,
        },
      });
      try {
        const body = {
          time_range: normalizeWafEventTimeRange(time_range),
          count: rows_per_page,
          from: from,
          conditions: conditions || [],
          action: action ?? WafAction.ALL,
          sort: { field: "timestamp", order: "desc" },
        };
        if (curProjectId) body.project_id = curProjectId;
        if (site_id && site_id !== "all") body.site_id = site_id;
        const response = await axios.post("log/waf_event", body, { signal });
        const eventsData = response.data.data || [];
        const totalCount = response.data.total ?? (Array.isArray(eventsData) ? eventsData.length : 0);
        dispatch({
          type: GET_SMARTPARSE_EVENTS,
          payload: {
            smartParseEvents: Array.isArray(eventsData) ? eventsData : [],
          },
        });
        dispatch({
          type: GET_TOTAL_SMARTPARSE_EVENTS_COUNT,
          payload: {
            total_smartparse_events_count: totalCount,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_SMARTPARSE_EVENTS,
          payload: {
            smartParseEvents: [],
          },
        });
        dispatch({
          type: GET_TOTAL_SMARTPARSE_EVENTS_COUNT,
          payload: {
            total_smartparse_events_count: 0,
          },
        });
        setErr(err?.message || String(err));
      }
    },
    [setErr, curProjectId]
  );

  const getSmartParseStats = useCallback(
    async (setWafEventController, site_id, time_range, conditions, init = true) => {
      if (init) {
        dispatch({
          type: GET_SMARTPARSE_EVENT_STATS,
          payload: {
            smartParseEventStats: null,
          },
        });
      }
      const controller = new AbortController();
      const signal = controller.signal;
      setWafEventController(controller);
      try {
        const body = {
          time_range: time_range,
          conditions: conditions,
        };
        if (curProjectId) body.project_id = curProjectId;
        if (site_id && site_id !== "all") body.site_id = site_id;
        const response = await axios.post("log/smart_parse_stats", body, { signal });
        dispatch({
          type: GET_SMARTPARSE_EVENT_STATS,
          payload: {
            smartParseEventStats: response.data,
          },
        });
      } catch (err) {
        if ("canceled" === err.message) return;
        dispatch({
          type: GET_SMARTPARSE_EVENT_STATS,
          payload: {
            smartParseEventStats: null,
          },
        });
      }
    },
    [curProjectId]
  );

  return (
    <EventContext.Provider
      value={{
        ...state,
        getEvents,
        getEvents2,
        getEvent,
        getFwEvents,
        getOnlyFwEvents,
        getFwEvent,
        getOnlyEvents,
        getOnlyEvents2,
        getBotEvents,
        getOnlyBotEvents,
        getBotEvent,
        getRlEvents,
        getOnlyRlEvents,
        getRlEvent,
        getSmartParseEvents,
        getOnlySmartParseEvents,
        getSmartParseEvent,
        getSmartParseEventGroup,
        getSmartParseStats,
        getWafEventStats,
        getFwEventStats,
        getBotEventStats,
        getRlEventStats,
        setErr,
      }}
    >
      {children}
    </EventContext.Provider>
  );
}

export { EventContext, EventProvider };
